import React from "react"
import useIsMobile from "@/shared/use_is_mobile"
import VenueImageGalleryDesktop from "./desktop"
import VenueImageGalleryMobile from "./mobile"
import type { VenueImageGalleryProps } from "./types"

const VenueImageGallery: React.FC<VenueImageGalleryProps> = (props) => {
  const isMobile = useIsMobile()
  return isMobile ? <VenueImageGalleryMobile {...props} /> : <VenueImageGalleryDesktop {...props} />
}

export default VenueImageGallery
